export var FIRST_AXES_VIEW = 'first-axes-view';
export var SECOND_AXES_VIEW = 'second-axes-view';
/** 对称条形图的分组 key 值 */
export var SERIES_FIELD_KEY = 'series-field-key';